import styled from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const Game = styled(Horizontal)`
  display: none;
  @media ${laptopAndAbove} {
    display: flex;
    width: 176px;
    padding: 0 var(--unit);
  }
`;

const GameSkeleton = styled(Skeleton)`
  width: 100%;
  height: var(--triple-unit);
`;
const CalendarSkeleton = styled(Skeleton)`
  flex-shrink: 0;
  width: var(--triple-unit);
  height: var(--triple-unit);
`;

export const UpcomingGamesSkeleton = () => {
  return (
    <Game>
      <GameSkeleton />
      <CalendarSkeleton />
    </Game>
  );
};
